import Vue from 'vue'
import VueAxios from 'vue-axios'
import VeeValidate, { Validator } from 'vee-validate'

import messages from 'vee-validate/dist/locale/bg'

import App from '@/App.vue'
import { createRouter } from './router.js'
import { createStore } from './store.js'
import { sync } from 'vuex-router-sync'
import { egnValidator } from './helpers.js'

import vuetify from '@/vuetify.js'

export function createApp (context) {
  // add custom EGN validator to VeeValidate
  Validator.extend('egn', egnValidator)

  // configure VeeValidate messages and field names
  Validator.localize({ bg: Object.assign(messages, {
    messages: Object.assign(messages.messages, {
      length: (field, [length, max]) => {
        if (max) {
          return `Полето ${field} трябва да е с дължина между ${length} и ${max} знака.`
        }

        return `Полето ${field} трябва да е с дължилна ${length} знака.`
      },
      digits: (field, [length]) => `Полето ${field} трябва да е цифрово и да съдържа точно ${length} цифри.`
    }),

    attributes: {
      first_name: '"Име"',
      middle_name: '"Презиме"',
      last_name: '"Фамилия"',
      email: '"Електронна поща"',
      tel: '"Телефон"',
      egn: '"ЕГН"',
      place: '"Населено място"',
      province: '"Област"',
      code: '"Регистрационен код"',
      password: '"Парола"',
      passwordConfirm: '"Парола"',
      toc: ' ',
      title: 'Заглавие',
      content: 'Съдържание',
      description: 'Описание',
    }
  }) })

  Vue.config.productionTip = false

  // load VeeValidate
  Vue.use(VeeValidate, { locale: 'bg' })

  // load Axios
  Vue.use(VueAxios, context.axios)

  // create router and vuex store
  const router = createRouter()
  const store = createStore(context)

  // sync router state into the store
  sync(store, router)

  router.onReady(() => {
    store.dispatch('initUser')

    router.beforeEach((to, from, next) => {
      // if going to the log in form but already logged in, redirect to profile page
      if (to.path === '/вход' && store.getters.loggedIn) {
        next({ path: '/профил' })
      }

      // if route requires login and user is not logged in, redirect to log in form
      if (to.matched.some(link => link.meta.requiresAuth) && !store.getters.loggedIn) {
        next({
          path: '/вход',
          query: { redirect: to.fullPath }
        })
      }

      // normal routing
      next()
    })
  })

  const app = new Vue({
    router,
    store,
    vuetify,
    data: {
      url: context.url
    },
    render (createEl) {
      return createEl(App)
    }
  })

  return { app, router, store }
}
